var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5L18.2833 4.89502L22.3473 4.88729L23.5958 8.75481L26.8882 11.1373L25.625 15L26.8882 18.8627L23.5958 21.2452L22.3473 25.1127L18.2833 25.105L15 27.5L11.7167 25.105L7.65271 25.1127L6.40421 21.2452L3.11182 18.8627L4.37502 15L3.11182 11.1373L6.40421 8.75481L7.65271 4.88729L11.7167 4.89502L15 2.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15L13.75 18.125L20 11.875",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSucess);
export default __webpack_public_path__ + "static/media/icon-sucess.e98f52668604b330d27d77fc86f8e40a.svg";
export { ForwardRef as ReactComponent };